module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app-nav"
    }
  }, [_c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("MAIN NAVIGATION")]), _vm._v(" "), _c('li', {
    staticClass: "active treeview"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" Summary")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/engagement"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" Engagement")])], 1)])]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/channels"
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" "), _c('span', [_vm._v("Channels")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "active treeview"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "treeview-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/apps"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" View")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/new"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-o"
  }), _vm._v(" Create")])], 1)])]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/menu"
    }
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" "), _c('span', [_vm._v("Welcome Menu")])])], 1), _vm._v(" "), _c('li', {
    staticClass: "treeview"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.exitApp
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" Logout\n      ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" "), _c('span', [_vm._v("Dashboard")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  }), _vm._v(" "), _c('span', [_vm._v("Generic SMS Apps")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right-container"
  }, [_c('i', {
    staticClass: "fa fa-angle-left pull-right"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-043183de","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nav.vue
// module id = DhH4
// module chunks = 1